import { Form, Formik } from 'formik';
import Button from '../../atoms/Button';
import { StyledErrorMessage } from '../../atoms/TextInput/styled';
import ButtonWithIcon from '../../molecules/ButtonWithIcon';
import LogoWithTitle from '../../molecules/LogoWithTitle';

import TextField from '../../molecules/TextField';
import {
  FieldWrapper,
  ForgotPasswordStepOneContainer,
  FormWrapper,
  Subheader,
} from './ForgotPasswordStepOne.styled';
import {
  forgotPasswordSchema,
  ForgotPasswordValues,
} from './ForgotPasswordStepOne.types';

interface ForgotPasswordStepOneProps {
  onSubmit: (values: ForgotPasswordValues) => void;
  error?: string;
}

/*TODO: We should lift the <Formik> component up to the parent. This will make it easier to set network errors and test in storybook using Formik Addon
https://github.com/bbbtech/storybook-formik
*/

const ForgotPasswordStepOne = (props: ForgotPasswordStepOneProps) => {
  return (
    <ForgotPasswordStepOneContainer>
      <LogoWithTitle title='Forgot Password?' gap={80} />
      <Subheader>We'll send you reset instructions.</Subheader>
      <FormWrapper>
        <Formik
          initialValues={{ email: '' }}
          onSubmit={(values) => props.onSubmit(values)}
          validationSchema={forgotPasswordSchema}
        >
          {({ errors }) => (
            <Form>
              <FieldWrapper>
                <TextField
                  name='email'
                  size='lg'
                  placeholder='Email'
                  errorMessage={errors.email}
                />
              </FieldWrapper>

              <Button size='lg' variant='primary' type='submit' block>
                CONTINUE
              </Button>
              {props.error ? (
                <StyledErrorMessage>{props.error}</StyledErrorMessage>
              ) : null}
            </Form>
          )}
        </Formik>
      </FormWrapper>
    </ForgotPasswordStepOneContainer>
  );
};

export default ForgotPasswordStepOne;
